export default __webpack_public_path__ + "static/media/2.e113c0dd.svg";